import React from 'react';
import { AuthHeader, AuthArtwork } from './AuthParts';

export default function BurgerBotTemplate({ children }) {
    return <div className="auth-page auth-burgerbot" data-auth-template="burgerbot"><section className="auth-pane"><AuthHeader burgerbot /><main className="auth-content">{children}</main><p className="auth-platform-note">Единый аккаунт IT-Burger</p></section><AuthArtwork /></div>;
}
